import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/login/auth.service';

export const TokenAccessInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const token = authService.getToken();
    const exceptions = ['login'];
    const currentpath = req.url;

    if (exceptions.includes(currentpath)) {
        return next(req);
    }

    if (token) {
        const authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token.access}`,
            },
        });
        return next(authReq);
    }

    return next(req);
};
